export enum ValidationStringLengthEnum {
  SMALL = 10,
  DEFAULT = 40,
  LONG = 255,
  XL = 2000,
  XXL = 30000,
}
